<template>
  <div class="row">
    <div class="offset-md-4 col-4 col-md-1 prev-month align-self-center" v-on:click="goPrevMonth">
      <svg viewBox="0 0 17 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="si-glyph si-glyph-arrow-left">
        <title>1225</title>
        <defs></defs>
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <path d="M10.978,1.162 C10.978,1.387 10.916,1.612 10.782,1.812
          L6.626,8.041 L10.823,14.078 C11.182,14.619
           11.036,15.348 10.495,15.707 C9.956,16.068
            9.224,15.922 8.865,15.382 L4.235,8.694 C3.971,8.3 3.969,7.786
           4.233,7.39 L8.822,0.51 C9.182,-0.032
            9.914,-0.178 10.454,0.181 C10.795,0.409 10.978,0.782
           10.978,1.162 L10.978,1.162 Z" fill="#434343" class="si-glyph-fill"></path>
        </g>
      </svg>
    </div>
    <div class="col-4 col-md-2 align-self-center month"
         v-bind:class="{ current: isCurrentMonth }" v-on:click="goCurrentMonth">
      <transition :name="slideWay" mode="out-in">
        <h2 :key="activeMonth">{{ monthTitle }}</h2>
      </transition>
    </div>
    <div class="col-4 col-md-1 next-month align-self-center" v-on:click="goNextMonth">
      <svg viewBox="0 0 17 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="si-glyph si-glyph-arrow-right">
        <title>1178</title>
        <defs></defs>
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <path d="M6.077,1.162 C6.077,1.387 6.139,1.612 6.273,1.812
           L10.429,8.041 L6.232,14.078 C5.873,14.619 6.019,15.348
            6.56,15.707 C7.099,16.068 7.831,15.922 8.19,15.382
             L12.82,8.694 C13.084,8.3 13.086,7.786 12.822,7.39
              L8.233,0.51 C7.873,-0.032 7.141,-0.178 6.601,0.181
               C6.26,0.409 6.077,0.782 6.077,1.162 L6.077,1.162 Z"
                fill="#434343" class="si-glyph-fill"></path>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapState([
      'activeMonth'
    ]),
    ...mapGetters([
      'slideWay'
    ]),
    monthTitle() {
      return this.$store.state.months[this.activeMonth - 1].fr;
    },
    isCurrentMonth() {
      const now = new Date();
      return now.getMonth() === this.activeMonth;
    },
  },
  methods: {
    goPrevMonth() {
      this.$store.dispatch('goBackward');
    },
    goNextMonth() {
      this.$store.dispatch('goForward');
    },
    goCurrentMonth() {
      this.$store.dispatch('goCurrent');
    }
  }
};
</script>

<style scoped lang="scss">
  .row {
    opacity: 0.97;
    margin-bottom: 20px;

    @include media-breakpoint-up(md) {
      & {
        margin-bottom: 30px;
      }
    }
  }

  .month {
    overflow: hidden;
  }

  h2 {
    color: $title-color;
    font-family: 'Delius Swash Caps', cursive;
    // font-weight: bold;
    text-align: center;
    font-size: 1.25rem;

    margin-bottom: 0;
    backface-visibility: hidden;

    @include media-breakpoint-up(md) {
      & {
        font-size: 1.4375rem;
      }
    }
  }

  .prev-month, .next-month, .month {
    cursor: pointer;

    &.current {
      cursor: default;
    }
  }

  .prev-month {
    text-align: right;
  }

  .next-month {
    text-align: left;
  }

  .si-glyph {
    width:16px;
    height:16px;
  }

  .si-glyph * {
    fill: darken($title-color, 20%);
  }

  /* month enter */

  .slide-prev-enter {
    transform: translateX(-100%);
  }

  .slide-next-enter {
    transform: translateX(100%);
  }

  .slide-current-enter {
    transform: translateY(-100%);
  }

  .slide-prev-enter-to, .slide-next-enter-to, .slide-current-enter-to {
    transform: translate(0%, 0%);
    transition-duration: 250ms;
  }

  /* month leave */

  .slide-prev-leave-active, .slide-next-leave-active, .slide-current-leave-active {
    transition-duration: 200ms;
  }

  .slide-prev-leave-active {
    transform: translateX(100%);
  }

  .slide-next-leave-active {
    transform: translateX(-100%);
  }

  .slide-current-leave-active {
    transform: translateY(100%);
  }
</style>
